export default function getShepherdSelector(selector = '') {
  if (!selector) return null;

  return `[data-shepherd="${selector}"]`;
}
